import PropTypes from 'prop-types'
import React from 'react'

import Icon from 'components/Icon'
import { Text } from 'styles/components/typography'

import './IconInSquare.scss'

/**
 * IconInSquare component to show icons inside square
 * @param {object} props - properties of component
 * @return {Component} Component — IconInSquare
 */
const IconInSquare = props => {
  const {
    icon,
    iconBottom,
    iconLeft,
    iconTop,
    iconH,
    iconW,
    description,
  } = props

  return (
    <div className="icon-in-square">
      <div className="icon-in-square__wrapper">
        <div className="icon-in-square__square" />
        <div
          className="icon-in-square__icon"
          style={{
            height: iconH,
            width: iconW,
            left: iconLeft,
            top: iconTop,
            bottom: iconBottom,
          }}
        >
          <Icon id={icon} />
        </div>
      </div>
      {description ? (
        <div className="icon-in-square__description mt-2 mt-md-3">
          <Text dangerouslySetInnerHTML={{ __html: description }} />
        </div>
      ) : null}
    </div>
  )
}

IconInSquare.propTypes = {
  /** Code of icon (look at Icon component) */
  icon: PropTypes.string.isRequired,

  /** Description */
  description: PropTypes.string,

  /** Icon bottom position */
  iconBottom: PropTypes.string,

  /** Icon height */
  iconH: PropTypes.string,

  /** Icon left poisition */
  iconLeft: PropTypes.string,

  /** Icon top position */
  iconTop: PropTypes.string,

  /** Icon width */
  iconW: PropTypes.string,
}

IconInSquare.defaultProps = {
  description: '',
  iconBottom: 'auto',
  iconH: '100%',
  iconLeft: '0',
  iconTop: '0',
  iconW: '100%',
}

export default IconInSquare
